import {
  LoadingOutlined,
  ReloadOutlined,
  SendOutlined,
} from "@ant-design/icons";
import { Button, Col, Form, Row, Spin } from "antd";
import React, { useEffect, useState } from "react";
import "./index.css";

import { Helmet } from "react-helmet";
import Api from "../../apis/Api";
import LockCertificateApi from "../../apis/LockCertificateApi";
import unlock from "../../assets/img/unlock.png";
import {
  disableViewTutorial,
  getParamFromUrl,
  isNullOrEmpty,
  showNotification,
} from "../../common";
import FiledNameFromLockCer, {
  getFiledByType,
  getKeyByFiled,
} from "../../common/FiledNameFromLockCer";
import Prefixs from "../../common/Prefixs";
import SupportStatus from "../../common/SupportStatus";
import { getValueByPrefix } from "../../common/Titles";
import ModalPromotion from "../ModalPromotion";
import FailOtp from "../otp/FailOtp";
import ContactInfo from "./ContactInfo";
import Header from "./Header";
import ProfileMissing from "./ProfileMissing";
import Footer from "../footer";
import GloabalConst from "../../common/GloabalConst";
import { getTutorialCodeByPrefix } from "../../common/TutorialCode";

const LockCertificate = () => {
  const [loading, setLoading] = useState(false);
  const [url, setUrl] = useState("");
  const [isOpenModalProm, setIsOpenModalProm] = useState(false);
  const [linkPromotion, setLinkPromotion] = useState("");
  const [isFinish, setIsFinish] = useState(false);

  const fileAdditionalInit = {
    [FiledNameFromLockCer.TC_GTPL.filed]: {
      fileName: "",
      type: "",
      data: "",
    },
    [FiledNameFromLockCer.TC_CMND_NDD.filed]: {
      fileName: "",
      type: "",
      data: "",
    },
    [FiledNameFromLockCer.TC_DK0101.filed]: {
      fileName: "",
      type: "",
      data: "",
    },
    [FiledNameFromLockCer.CN_XACNHANTOCHUC.filed]: {
      fileName: "",
      type: "",
      data: "",
    },
    [FiledNameFromLockCer.CN_CMND.filed]: {
      fileName: "",
      type: "",
      data: "",
    },
    [FiledNameFromLockCer.CN_DK0102.filed]: {
      fileName: "",
      type: "",
      data: "",
    },
  };
  const [fileAdditionals, setFileAdditionals] = useState([]);

  // const visbleFilesInit = {
  //   [FiledNameFromLockCer.TC_GTPL.filed]: false,
  //   [FiledNameFromLockCer.TC_CMND_NDD.filed]: false,
  //   [FiledNameFromLockCer.TC_DK0101.filed]: false,
  //   [FiledNameFromLockCer.CN_XACNHANTOCHUC.filed]: false,
  //   [FiledNameFromLockCer.CN_CMND.filed]: false,
  //   [FiledNameFromLockCer.CN_DK0102.filed]: false,
  //   [FiledNameFromLockCer.LINK_DK02.filed]: false,
  //   type: null,
  //   linkDk02: null,
  //   certificateSerial: "",
  // };

  // const [visbleFiles, setVisbleFiles] = useState([]);

  const [lockTokenResponse, setLockTokenResponse] = useState([]);
  const [tokenProgramResponse, setTokenProgramResponse] = useState({});
  const [lastAttemptChecked, setLastAttemptChecked] = useState(false);

  const [form] = Form.useForm();

  useEffect(() => {
    localStorage.setItem(
      GloabalConst.TUTORIAL_CODE,
      getTutorialCodeByPrefix(window.location.pathname)
    );

    const urlCurrent = window.location.href;
    setUrl(urlCurrent);
    const dataParam = getParamFromUrl("data");
    if (urlCurrent.includes(Prefixs.LOCK_WRONG_PIN)) {
      if (!isNullOrEmpty(dataParam)) {
        auth(dataParam, urlCurrent);
      } else {
        showNotification("error", "Không tìm thấy thông tin", "Thông báo");
      }
    } else {
      fetchDataDetail(urlCurrent);
    }

    const popupParam = getParamFromUrl("openPopup");
    if (!isNullOrEmpty(popupParam)) {
      setIsOpenModalProm(true);
      setLinkPromotion(popupParam);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const auth = async (data, urlCurrent) => {
    setLoading(true);
    Api.auth(data)
      .then((res) => {
        if (res && res.status === 200 && res.data.data) {
          sessionStorage.setItem("token", res.data.data.jwt);
          fetchDataDetail(urlCurrent);
          setLoading(false);
        }
      })
      .catch((error) => {
        console.log("error: ", error);
        showNotification("error", error.response.data.message, "Thông báo");
        setLoading(false);
      });
  };

  const onFinish = async (values) => {
    setLoading(true);
    let maps = [];
    fileAdditionals.forEach((element) => {
      let fileRequest = [];
      for (const key in FiledNameFromLockCer) {
        if (FiledNameFromLockCer.hasOwnProperty(key)) {
          const enumItem = FiledNameFromLockCer[key];
          if (!isNullOrEmpty(element.files[enumItem.filed]?.data)) {
            getFile(fileRequest, enumItem.filed, element.files);
          }
        }
      }
      const fileSerial = {
        certificateSerial: element.certificateSerial,
        linkDk02: element.linkDk02,
        files: fileRequest,
      };
      maps.push(fileSerial);
    });

    let request = {
      ...values,
      maps: maps,
    };

    if (url.includes(Prefixs.LOCK_UNPAID)) {
      handleRequest(LockCertificateApi.debtSettlement, 201, request);
    } else if (url.includes(Prefixs.LOCK_NOT_ENOUGH_DOC)) {
      isNullOrEmpty(lockTokenResponse.id)
        ? handleRequest(LockCertificateApi.postProfileMissing, 201, request)
        : handleRequest(
          LockCertificateApi.putProfileMissing,
          200,
          lockTokenResponse.id,
          request
        );
    } else if (url.includes(Prefixs.LOCK_REVOKE)) {
      handleRequest(LockCertificateApi.revoke, 201, request);
    } else if (url.includes(Prefixs.LOCK_WRONG_PIN)) {
      handleRequest(LockCertificateApi.wrongpin, 201, request);
    } else if (url.includes(Prefixs.LOCK_AUTHEN)) {
      handleRequest(LockCertificateApi.authenticateInfo, 201, request);
    }
  };

  const handleRequest = async (apiFunction, status, ...args) => {
    try {
      const res = await apiFunction(...args);
      if (res && res.status === status && res.data.data) {
        setIsFinish(true);
        setLockTokenResponse(res.data.data);
        if (
          url.includes(Prefixs.LOCK_NOT_ENOUGH_DOC) &&
          res.data.data.details
        ) {
          handleLockTokenDetails(res.data.data.details, fileAdditionals);
        }
      }
    } catch (error) {
      console.log("error: ", error);
      showNotification("error", error.response.data.message, "Thông báo");
    } finally {
      setLoading(false);
    }
  };

  const getFile = (fileRequest, filed, files) => {
    fileRequest.push({
      id: files[filed].id,
      fileName: files[filed].fileName,
      type: getKeyByFiled(files[filed].type),
      data: files[filed].data,
    });
  };

  const fetchDataDetail = async (urlParam) => {
    setLoading(true);
    try {
      const res = await LockCertificateApi.detail();
      if (res && res.status === 200 && res.data.data) {
        handleDataResponse(res.data.data, url ? url : urlParam);
        handleDataOtpResponse(res.data.data, url ? url : urlParam);
      }
    } catch (error) {
      console.log("error: ", error);
      showNotification("error", error.message, "Thông báo");
    } finally {
      setLoading(false);
    }
  };

  const fetchDataById = async () => {
    setLoading(true);
    try {
      if (lockTokenResponse && lockTokenResponse.id) {
        const res = await LockCertificateApi.detailById(lockTokenResponse.id);
        if (res && res.status === 200 && res.data.data) {
          setLockTokenResponse(res.data.data[0]);
          setIsFinish(res.data.data[0].status === SupportStatus.WAITING);
          if (
            url.includes(Prefixs.LOCK_NOT_ENOUGH_DOC) &&
            res.data.data.details
          ) {
            handleLockTokenDetails(res.data.data[0].details, fileAdditionals);
          }
        }
      } else {
        showNotification("error", "Không tìm thấy thông tin hồ sơ", "");
      }
    } catch (error) {
      console.log("error: ", error);
      showNotification("error", error.message, "Thông báo");
    } finally {
      setLoading(false);
    }
  };

  const handleDataResponse = (data, urlParam) => {
    let fileAdditionalNews = [];
    if (data.tokenProgramDetail) {
      // Chỉ dành cho các trường hợp thiếu hồ sơ
      if (
        urlParam.includes(Prefixs.LOCK_NOT_ENOUGH_DOC) &&
        data.tokenProgramDetail
      ) {
        const visbleFilesArray = [];
        data.tokenProgramDetail.forEach((value) => {
          const files = {
            [FiledNameFromLockCer.TC_GTPL.filed]: {
              fileName: "",
              type: "",
              data: "",
              view: value.tcGtpl && value.tcGtpl === 1,
            },
            [FiledNameFromLockCer.TC_CMND_NDD.filed]: {
              fileName: "",
              type: "",
              data: "",
              view: value.tcCmndNdd && value.tcCmndNdd === 1,
            },
            [FiledNameFromLockCer.TC_DK0101.filed]: {
              fileName: "",
              type: "",
              data: "",
              view: value.tcDk0101 && value.tcDk0101 === 1,
            },
            [FiledNameFromLockCer.CN_XACNHANTOCHUC.filed]: {
              fileName: "",
              type: "",
              data: "",
              view: value.cnXacnhantochuc && value.cnXacnhantochuc === 1,
            },
            [FiledNameFromLockCer.CN_CMND.filed]: {
              fileName: "",
              type: "",
              data: "",
              view: value.cnCmnd && value.cnCmnd === 1,
            },
            [FiledNameFromLockCer.CN_DK0102.filed]: {
              fileName: "",
              type: "",
              data: "",
              view: value.cnDk0102 && value.cnDk0102 === 1,
            },
          };
          const fileAdditionalSerial = {
            type: value.type,
            linkDk02: value.linkDk02,
            certificateSerial: value.certificateSerial,
            object: value.object,
            files: files,
            specifiedDate: value.specifiedDate,
          };
          fileAdditionalNews.push(fileAdditionalSerial);
        });
        // setFileAdditionals(fileAdditionalNews);
      }
      // Chỉ dành cho các trường hợp thiếu hồ sơ -end
    }
    if (data.lockTokenResponses && data.lockTokenResponses.length > 0) {
      const lockTokenResponse = data.lockTokenResponses[0];
      if (lockTokenResponse.details && lockTokenResponse.details.length > 0) {
        handleLockTokenDetails(lockTokenResponse.details, fileAdditionalNews);
      } else {
        setFileAdditionals(fileAdditionalNews);
      }
      form.setFieldsValue({
        name: lockTokenResponse.name,
        phone: lockTokenResponse.phone,
        email: lockTokenResponse.email,
      });
      setLockTokenResponse(lockTokenResponse);

      if (
        lockTokenResponse.status === SupportStatus.ACCEPT ||
        lockTokenResponse.status === SupportStatus.WAITINGUNLOCK
      ) {
        disableViewTutorial();
      }
      setIsFinish(lockTokenResponse.status === SupportStatus.WAITING);
    }
  };

  const handleDataOtpResponse = (data, urlParam) => {
    if (urlParam.includes(Prefixs.LOCK_AUTHEN) && data.tokenProgramResponse) {
      setTokenProgramResponse(data.tokenProgramResponse);
      if (
        !isNullOrEmpty(data.tokenProgramResponse.timeOTPRemaining) &&
        data.tokenProgramResponse.timeOTPRemaining === 0
      ) {
        setLastAttemptChecked(true);
      }
    }
  };

  const handleLockTokenDetails = (details, fileAdditionalNew) => {
    // Tạo resultMap từ details
    const resultMap = details.reduce((map, detail) => {
      const valueMap = {
        linkDk02: detail.linkDk02,
        files: detail.files,
      };
      map[detail.certificateSerial] = valueMap;
      return map;
    }, {});

    // Duyệt qua từng item trong fileAdditionalNew và cập nhật giá trị
    const updatedFileAdditionalNew = fileAdditionalNew.map((item, index) => {
      const valueMap = resultMap[item.certificateSerial];
      if (!valueMap) {
        // Nếu không tìm thấy certificateSerial trong resultMap, trả về item như cũ
        return item;
      }

      let updatedFiles = { ...item.files };

      valueMap.files.forEach((file) => {
        const type = getFiledByType(file.type);

        // Cập nhật file theo type
        updatedFiles = {
          ...updatedFiles,
          [type]: {
            ...item.files[type],
            id: file.id,
            fileName: file.fileName,
            type: file.type,
            data: file.fileData,
            fileId: file.fileId,
            fileData: file.fileData,
          },
        };

        // Đặt giá trị vào form theo từng type
        if (
          type === FiledNameFromLockCer.TC_GTPL.filed ||
          type === FiledNameFromLockCer.CN_XACNHANTOCHUC.filed
        ) {
          form.setFieldsValue({
            [`${index}dkkd`]: file.fileName,
          });
        }
        if (
          type === FiledNameFromLockCer.CN_CMND.filed ||
          type === FiledNameFromLockCer.TC_CMND_NDD.filed
        ) {
          form.setFieldsValue({
            [`${index}cmnd`]: file.fileName,
          });
        }
        if (
          type === FiledNameFromLockCer.CN_DK0102.filed ||
          type === FiledNameFromLockCer.TC_DK0101.filed
        ) {
          form.setFieldsValue({
            [`${index}dk01`]: file.fileName,
          });
        }
      });

      // Trả về item đã cập nhật
      return {
        ...item,
        files: updatedFiles,
      };
    });

    // Cập nhật state với giá trị mới
    setFileAdditionals(updatedFileAdditionalNew);
    console.log('updatedFileAdditionalNew: ', updatedFileAdditionalNew);
  };


  return (
    <Spin
      spinning={loading}
      tip="Vui lòng đợi..."
      indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
    >
      <Helmet>
        <title>{getValueByPrefix(window.location.pathname)}</title>
      </Helmet>
      <Row
        justify="center"
        align="middle"
        style={{ minHeight: "100vh" }}
        className="lock-certificate-container"
      >
        <Header
          url={url}
          lockTokenResponse={lockTokenResponse}
          tokenProgramResponse={tokenProgramResponse}
          lastAttemptChecked={lastAttemptChecked}
        ></Header>
        {lockTokenResponse &&
          (lockTokenResponse.status === SupportStatus.ACCEPT ||
            lockTokenResponse.status === SupportStatus.WAITINGUNLOCK) ? (
          <Row className="lock-certificate-body">
            <img src={unlock} className="unlock-img" alt="unlock-img" />
          </Row>
        ) : (
          <>
            {lastAttemptChecked ? (
              <FailOtp />
            ) : (
              <Form
                onFinish={onFinish}
                layout="vertical"
                className="lock-certificate-form"
                form={form}
              >
                {lockTokenResponse.status === SupportStatus.REFUSE && (
                  <span className="text-is-finish">
                    Lý do Hồ sơ bổ sung bị từ chối:{" "}
                    {lockTokenResponse.reasonRefusal}
                  </span>
                )}

                <ContactInfo
                  url={url}
                  lockTokenResponse={lockTokenResponse}
                  isFinish={isFinish}
                  setLoading={setLoading}
                  form={form}
                  tokenProgramResponse={tokenProgramResponse}
                  setTokenProgramResponse={setTokenProgramResponse}
                  setLastAttemptChecked={setLastAttemptChecked}
                  lastAttemptChecked={lastAttemptChecked}
                />
                {/* Hồ sơ cần bổ sung */}
                {url.includes(Prefixs.LOCK_NOT_ENOUGH_DOC) && (
                  <ProfileMissing
                    lockTokenResponse={lockTokenResponse}
                    isFinish={isFinish}
                    // visbleFiles={visbleFiles}
                    setFileAdditionals={setFileAdditionals}
                    fileAdditionals={fileAdditionals}
                    setLoading={setLoading}
                    form={form}
                  />
                )}
                {/* Buttons */}
                {isFinish ? (
                  <>
                    {(url.includes(Prefixs.LOCK_UNPAID) ||
                      url.includes(Prefixs.LOCK_REVOKE) ||
                      url.includes(Prefixs.LOCK_WRONG_PIN)) && (
                        <span className="text-is-finish">
                          Thông tin của Quý khách đã được gửi đến nhà cung cấp.
                          Vui lòng giữ liên lạc để được hỗ trợ.
                        </span>
                      )}
                    {url.includes(Prefixs.LOCK_NOT_ENOUGH_DOC) && (
                      <span className="text-is-finish">
                        Thông tin của Quý khách đã được gửi đến nhà cung cấp.
                        Vui lòng chờ nhà cung cấp kiểm tra và xác minh hồ sơ
                      </span>
                    )}
                    <Form.Item>
                      <Row justify="center">
                        <Col>
                          <Button
                            icon={<ReloadOutlined />}
                            type="primary"
                            onClick={fetchDataById}
                          >
                            Tải lại trang
                          </Button>
                        </Col>
                      </Row>
                    </Form.Item>
                  </>
                ) : (
                  <Form.Item>
                    <Row justify="center">
                      <Col>
                        <Button
                          icon={<SendOutlined />}
                          type="primary"
                          htmlType="submit"
                        >
                          Gửi thông tin
                        </Button>
                      </Col>
                    </Row>
                  </Form.Item>
                )}
              </Form>
            )}
          </>
        )}

        {/* <Row className="lock-certificate-footer">
          <span className="text-contact">
            Tổng đài: <span className="text-contact-hig">1900.2066</span> -
            Nhánh 1| Email:{" "}
            <span className="text-contact-hig">support@fastca.vn</span> |
            Website:
            <span className="text-contact-hig"> https://fastca.vn/</span>{" "}
          </span>
        </Row> */}
        <Footer></Footer>
      </Row>
      {isOpenModalProm ? (
        <ModalPromotion
          setModalOpen={setIsOpenModalProm}
          isModalOpen={isOpenModalProm}
          link={linkPromotion}
        ></ModalPromotion>
      ) : (
        ""
      )}
    </Spin>
  );
};

export default LockCertificate;
